const em = px => `${px / 16}em`;

const mountMedia = val => `@media screen and (max-width: ${em(val)})`;

export const breakpoints = {
  mobile: 630,
  tablet: 920,
  desktop: 1120
};

if (typeof breakpoints !== 'undefined' && breakpoints && breakpoints === Object(breakpoints) && Object.isExtensible(breakpoints) && !breakpoints.hasOwnProperty('__filemeta')) {
  Object.defineProperty(breakpoints, '__filemeta', {
    configurable: true,
    value: {
      name: "breakpoints",
      filename: "../../node_modules/gatsby-theme-docz/src/theme/breakpoints.js"
    }
  });
}

export const media = {
  mobile: mountMedia(breakpoints.mobile),
  tablet: mountMedia(breakpoints.tablet),
  desktop: mountMedia(breakpoints.desktop)
};

if (typeof media !== 'undefined' && media && media === Object(media) && Object.isExtensible(media) && !media.hasOwnProperty('__filemeta')) {
  Object.defineProperty(media, '__filemeta', {
    configurable: true,
    value: {
      name: "media",
      filename: "../../node_modules/gatsby-theme-docz/src/theme/breakpoints.js"
    }
  });
}